var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 20,
    viewBox: "0 0 17.5 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calendar",
    d: "M4.375,0A.627.627,0,0,1,5,.625V2.5h7.5V.625a.625.625,0,1,1,1.25,0V2.5H15A2.5,2.5,0,0,1,17.5,5V17.5A2.5,2.5,0,0,1,15,20H2.5A2.5,2.5,0,0,1,0,17.5V5A2.5,2.5,0,0,1,2.5,2.5H3.75V.625A.627.627,0,0,1,4.375,0ZM16.25,7.5h-15v10A1.249,1.249,0,0,0,2.5,18.75H15a1.249,1.249,0,0,0,1.25-1.25ZM15,3.75H2.5A1.249,1.249,0,0,0,1.25,5V6.25h15V5A1.249,1.249,0,0,0,15,3.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar.36bc2f8d89bd762393199c7c878ca055.svg";